export default __webpack_public_path__ + "static/media/nearshortit.03deaf73.svg";